import axios from "axios";
import { apiBaseUrl } from "./appconst";

/* ================= LIST USERS ================= */
export async function getAdminUsers(search = "", role = "All") {
  try {

    const fd = new FormData();
    fd.append("search", search);
    fd.append("role", role);

    const response = await axios.post(
      `${apiBaseUrl}admin/users/list`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;

  } catch (error) {
    console.error("getAdminUsers error:", error);
    return { status: false, type: "danger", success: "Users load failed" };
  }
}


/* ================= CREATE USER ================= */
export async function createAdminUser(name, email, role) {
  try {

    const fd = new FormData();
    fd.append("name", name);
    fd.append("email", email);
    fd.append("role", role);

    const response = await axios.post(
      `${apiBaseUrl}admin/users/create`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;

  } catch (error) {
    console.error("createAdminUser error:", error);
    return { status: false, type: "danger", success: "User create failed" };
  }
}


/* ================= UPDATE USER ================= */
export async function updateAdminUser(user_id, name, role) {
  try {

    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("name", name);
    fd.append("role", role);

    const response = await axios.post(
      `${apiBaseUrl}admin/users/update`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;

  } catch (error) {
    console.error("updateAdminUser error:", error);
    return { status: false, type: "danger", success: "User update failed" };
  }
}


/* ================= CHANGE STATUS ================= */
export async function changeAdminUserStatus(user_id, status) {
  try {

    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("status", status);

    const response = await axios.post(
      `${apiBaseUrl}admin/users/status`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;

  } catch (error) {
    console.error("changeAdminUserStatus error:", error);
    return { status: false, type: "danger", success: "Status change failed" };
  }
}


/* ================= RESET PASSWORD ================= */
export async function resetAdminUserPassword(user_id) {
  try {

    const fd = new FormData();
    fd.append("user_id", user_id);

    const response = await axios.post(
      `${apiBaseUrl}admin/users/reset-password`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;

  } catch (error) {
    console.error("resetAdminUserPassword error:", error);
    return { status: false, type: "danger", success: "Password reset failed" };
  }
}